import CostIcon from '../images/icons/cost.svg';
import EstimationsIcon from '../images/icons/estimation.svg';
import InvestigationIcon from '../images/icons/investigation.svg';

export const featuresData = [
	{
		text: 'Let\u2019s investigate your project concept and its current status together.',
		icon: InvestigationIcon,
	},
	{
		text: 'Expect an initial project scope proposal, time and cost estimation from us.',
		icon: CostIcon,
	},
	{
		text: 'The consultancy will be protected by the NDA.',
		icon: EstimationsIcon,
	},
];

export const requestPageConsultingData = [
	{
		text: 'Let\u2019s investigate your needs in the project together.',
		icon: InvestigationIcon,
	},
	{
		text: 'We can support your project with our experience and EMBIQ team.',
		icon: InvestigationIcon,
	},
	{
		text: 'The NDA will protect the consultancy.',
		icon: EstimationsIcon,
	},
];
